export enum AdbDialogMessagesEnum {
	DeviceConnectingSuccess = 'The device will be connected in a few seconds',
	DeviceConnectedSuccess = 'The device was successfully connected',
	DeviceAlreadyConnectedInfo = 'The device is already connected',
	DeviceReconnectedSuccess = 'The device will be reconnected in a few seconds',
	DeviceReconnectedError = 'The device is not ready for reconnecting',
	UpdateSpacedesk = 'The SpaceDesk app will be updated in a few seconds for selected devices',
	UpdateSpacedeskConfiguration = 'The SpaceDesk configuration will be updated in a few seconds for selected devices',
	InstallSpacedesk = 'The SpaceDesk app will be installed in a few seconds',
	StartedSpacedeskSuccess = 'The SpaceDesk app was successfully installed and run',
	DeviceConnectedErrorTitle = 'Wrong device IP',
	DeviceConnectedError = 'Check if your device IP matches the entered IP',
	DeviceRestarted = 'The selected devices will be restarted in a few seconds',
	SpaceDeskRestarted = 'The SpaceDesk app will be restarted in a few seconds for selected devices',
	SpacedeskIsNotInstalled = 'SpaceDesk is not installed',
	IpAddressChangeSuccess = 'IP address was successfully changed',
	UpdateSpacedeskFileSuccess = 'The SpaceDesk\'s file path was successfully uploaded',
	DeviceIsOffline = 'The device is offline. Press to reconnect the device.',
	TheIPAddressIsAlreadyListedInTheAvailableDevices = 'The IP address is already listed in the Available Devices',
	DeactivateDeviceMessage = 'Are you sure you want to disconnect the control from this device?',
	DeleteDeviceMessage = 'Are you sure you want to delete this android device from the list?',
	DeviceDeletingErrorTitle = 'The current device cannot be deleted.',

	DeviceADBConnectionMessage = 'Are you sure you want to connect this device to the ADB?',
	DeviceADBDisconnectionMessage = 'Are you sure you want to disconnect this device from the ADB?',
	DeviceADBSuccessConnectionMessage = 'was successfully connected to the ADB',
	DeviceADBSuccessDisconnectionMessage = 'was successfully disconnected from the ADB',

	WrongFileTypeUploadingTitle = 'Wrong file type',
	WrongFileTypeUploadingDescription = 'You can upload only \'apk\' files'
}
